export const getButtonVariantForHubConnection = (isConnected: boolean, isConnecting: boolean): "default" | "red" | "green" | "light"  => {
    if(isConnecting) {
        return "light";
    }
    if(isConnected) {
        return "red";
    }
    return "default";
}

export const getButtonTextForHubConnection = (isConnected: boolean, isConnecting: boolean)  => {
    if(isConnecting) {
        return "Łączenie";
    }
    if(isConnected) {
        return "Zakończ połączenie";
    }
    return "Rozpocznij podgląd na żywo";
}